<template>
  <QuoteRefrence />
</template>

<script>
import QuoteRefrence from "@/components/Ondemand/Bookings/QuoteRefrence.vue";

export default {
  components: {
    QuoteRefrence
  },
};
</script>

<style>

</style>
